import { theme, themeCM, themeVA, themeURB } from '@navent-re/global-styled';

const currentSite = process.env.REACT_APP_BUILD_SITE;

const themeREUIKITBySite = {
  UBPE: themeURB,
  ZPAR: theme,
  WIBR: theme,
  IWBR: theme,
  DVPE: theme,
  '24MX': theme,
  CAPA: theme,
  PLEC: theme,
  CMBR: themeCM,
  VAMX: themeVA
};

export const getThemeREUIKITBySite = () => {
  return themeREUIKITBySite[currentSite];
};
